import axiosClient from '../interceptors';
import { ApiRoutes } from '../routes/ApiRoutes';
import { getAPIUrl } from './BaseService';
import { RubricEntity, RubricTemplate } from '../types';

export async function getRubrics(): Promise<{ data: RubricEntity[] }> {
    const url = getAPIUrl() + ApiRoutes.RUBRICS;
    const response = await axiosClient.get<RubricEntity[]>(url);
    return { data: response.data };
}

export async function getRubricByClassroom(classroomId: string): Promise<RubricEntity | null> {
    const url = getAPIUrl() + ApiRoutes.RUBRICS;
    const response = await axiosClient.get<RubricEntity[]>(url, {
        params: { classroom_id: classroomId },
    });
    return response.data.length > 0 ? response.data[0] : null;
}

export async function getRubricTemplates(): Promise<{ data: RubricTemplate[] }> {
    const url = getAPIUrl() + ApiRoutes.RUBRIC_TEMPLATES;
    const response = await axiosClient.get<RubricTemplate[]>(url);
    return { data: response.data };
}

export async function createRubric(
    schoolId: string,
    name: string,
    categoryWeights: Record<string, number>,
    minPassing: number | null,
    gradingType: string,
    activeGradeSchemeId?: string | null,
    classroomId?: string | null,
    description?: string
): Promise<{ data: RubricEntity }> {
    const body = {
        school_id: schoolId,
        // classroom_id is an input convenience: when provided the BE links
        // the classroom to the (possibly reused) rubric.
        classroom_id: classroomId || null,
        name,
        description: description || null,
        category_weights: categoryWeights,
        min_passing: minPassing,
        active_grade_scheme_id: activeGradeSchemeId || null,
        grading_type: gradingType,
    };
    const url = getAPIUrl() + ApiRoutes.RUBRICS;
    const response = await axiosClient.post<RubricEntity>(url, body);
    return { data: response.data };
}

export async function updateRubric(
    rubricId: string,
    data: {
        name?: string;
        category_weights?: Record<string, number>;
        min_passing?: number | null;
        grading_type?: string;
        active_grade_scheme_id?: string | null;
        description?: string;
    }
): Promise<{ data: RubricEntity }> {
    const url = getAPIUrl() + ApiRoutes.RUBRICS + '/' + rubricId;
    const response = await axiosClient.patch<RubricEntity>(url, data);
    return { data: response.data };
}

export async function deleteRubric(rubricId: string): Promise<void> {
    const url = getAPIUrl() + ApiRoutes.RUBRICS + '/' + rubricId;
    await axiosClient.delete(url);
}
